module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cars-info"
    }
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.uploadVisible,
      "size": "tiny",
      "before-close": _vm.handleCloseUpload
    },
    on: {
      "update:visible": function($event) {
        _vm.uploadVisible = $event
      }
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.uploadURl,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadError,
      "headers": _vm.uploadHeaders,
      "multiple": "",
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    slot: "tip"
  }, [_vm._v("只能上传csv文件，且不超过5MB")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.carDialogTitle,
      "visible": _vm.addVisible,
      "size": "small",
      "before-close": _vm.handleCloseAdd
    },
    on: {
      "update:visible": function($event) {
        _vm.addVisible = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "form-add",
    attrs: {
      "inline": true,
      "model": _vm.addDialogData,
      "label-position": "right",
      "label-width": "148px"
    }
  }, [_c('p', [_vm._v("车辆信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "车牌号",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.plate_number),
      callback: function($$v) {
        _vm.addDialogData.plate_number = $$v
      },
      expression: "addDialogData.plate_number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "车辆VIN码",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.id),
      callback: function($$v) {
        _vm.addDialogData.id = $$v
      },
      expression: "addDialogData.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "车辆型号"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择车辆型号"
    },
    model: {
      value: (_vm.addDialogData.vehicle_type),
      callback: function($$v) {
        _vm.addDialogData.vehicle_type = $$v
      },
      expression: "addDialogData.vehicle_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "比亚迪E6",
      "value": "比亚迪E6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "北汽E5",
      "value": "北汽E5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ICCID号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.iccid),
      callback: function($$v) {
        _vm.addDialogData.iccid = $$v
      },
      expression: "addDialogData.iccid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "驱动电机布置型式/位置"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.motor_deploy_info),
      callback: function($$v) {
        _vm.addDialogData.motor_deploy_info = $$v
      },
      expression: "addDialogData.motor_deploy_info"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最高车速"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.max_velocity),
      callback: function($$v) {
        _vm.addDialogData.max_velocity = $$v
      },
      expression: "addDialogData.max_velocity"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("km/h")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纯电续驶里程"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.electric_endurance_mileage),
      callback: function($$v) {
        _vm.addDialogData.electric_endurance_mileage = $$v
      },
      expression: "addDialogData.electric_endurance_mileage"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("km")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "各档位传动比"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "readonly": "readonly",
      "icon": "caret-right"
    },
    model: {
      value: (_vm.addDialogData.gear_transmission_ratio.length),
      callback: function($$v) {
        _vm.addDialogData.gear_transmission_ratio.length = $$v
      },
      expression: "addDialogData.gear_transmission_ratio.length"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电机个数"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 10
    },
    on: {
      "change": _vm.handleChangeNumMotor
    },
    model: {
      value: (_vm.addDialogData.num_of_motor),
      callback: function($$v) {
        _vm.addDialogData.num_of_motor = $$v
      },
      expression: "addDialogData.num_of_motor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通用报警预置"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.common_alarm_value),
      callback: function($$v) {
        _vm.addDialogData.common_alarm_value = $$v
      },
      expression: "addDialogData.common_alarm_value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电池个数"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 10
    },
    on: {
      "change": _vm.handleChangeNumBattery
    },
    model: {
      value: (_vm.addDialogData.num_of_battery),
      callback: function($$v) {
        _vm.addDialogData.num_of_battery = $$v
      },
      expression: "addDialogData.num_of_battery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发动机编号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.engine_code),
      callback: function($$v) {
        _vm.addDialogData.engine_code = $$v
      },
      expression: "addDialogData.engine_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "燃油类型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.fuel_type),
      callback: function($$v) {
        _vm.addDialogData.fuel_type = $$v
      },
      expression: "addDialogData.fuel_type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "燃油标号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.fuel_flag),
      callback: function($$v) {
        _vm.addDialogData.fuel_flag = $$v
      },
      expression: "addDialogData.fuel_flag"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发动机最大输出转矩"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.max_output_torque),
      callback: function($$v) {
        _vm.addDialogData.max_output_torque = $$v
      },
      expression: "addDialogData.max_output_torque"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("N.米")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发动机最大输出功率"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.addDialogData.max_output_power),
      callback: function($$v) {
        _vm.addDialogData.max_output_power = $$v
      },
      expression: "addDialogData.max_output_power"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("W")])], 2)], 1), _vm._v(" "), _vm._l((_vm.addDialogData.battery_data), function(battery, index) {
    return _c('div', {
      staticClass: "battery"
    }, [_c('p', [_vm._v("电池信息" + _vm._s(index + 1))]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "电池编码"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "",
        "required": ""
      },
      model: {
        value: (battery.battery_sys_code),
        callback: function($$v) {
          battery.battery_sys_code = $$v
        },
        expression: "battery.battery_sys_code"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "电池类型"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择车辆型号"
      },
      model: {
        value: (battery.battery_type),
        callback: function($$v) {
          battery.battery_type = $$v
        },
        expression: "battery.battery_type"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "磷酸铁锂电池",
        "value": "磷酸铁锂电池"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "锰酸锂电池",
        "value": "锰酸锂电池"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "三元材料电池",
        "value": "三元材料电池"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "聚合物锂离子电池",
        "value": "聚合物锂离子电池"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "超级电容",
        "value": "超级电容"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "钛酸锂电池",
        "value": "钛酸锂电池"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "其它电池",
        "value": "其它电池"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "电池冷却方式"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (battery.battery_cooling_type),
        callback: function($$v) {
          battery.battery_cooling_type = $$v
        },
        expression: "battery.battery_cooling_type"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "电池总能量"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (battery.battery_energy_total),
        callback: function($$v) {
          battery.battery_energy_total = $$v
        },
        expression: "battery.battery_energy_total"
      }
    })], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.addDialogData.motor_data), function(motor, index) {
    return _c('div', {
      staticClass: "motor"
    }, [_c('p', [_vm._v("电机信息" + _vm._s(index + 1))]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "电机冷却方式"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (motor.motor_cooling_type),
        callback: function($$v) {
          motor.motor_cooling_type = $$v
        },
        expression: "motor.motor_cooling_type"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "额定电压"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (motor.rated_voltage),
        callback: function($$v) {
          motor.rated_voltage = $$v
        },
        expression: "motor.rated_voltage"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "最大工作电流"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (motor.max_work_current),
        callback: function($$v) {
          motor.max_work_current = $$v
        },
        expression: "motor.max_work_current"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "驱动机序号"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "",
        "r": ""
      },
      model: {
        value: (motor.motor_code),
        callback: function($$v) {
          motor.motor_code = $$v
        },
        expression: "motor.motor_code"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "驱动电机型号"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择型号"
      },
      model: {
        value: (motor.motor_model),
        callback: function($$v) {
          motor.motor_model = $$v
        },
        expression: "motor.motor_model"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "直流电动机",
        "value": "直流电动机"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "交流异步电动机",
        "value": "交流异步电动机"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "永磁式电动机",
        "value": "永磁式电动机"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "开关磁阻电机",
        "value": "开关磁阻电机"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "驱动电机最高转速"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (motor.motor_max_rev),
        callback: function($$v) {
          motor.motor_max_rev = $$v
        },
        expression: "motor.motor_max_rev"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("r/min")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "驱动电机峰值功率"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (motor.motor_peak_power),
        callback: function($$v) {
          motor.motor_peak_power = $$v
        },
        expression: "motor.motor_peak_power"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("w")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "驱动电机最大输出转矩"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (motor.motor_max_torque),
        callback: function($$v) {
          motor.motor_max_torque = $$v
        },
        expression: "motor.motor_max_torque"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("N.米")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "驱动电机峰值转矩"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (motor.motor_peak_torque),
        callback: function($$v) {
          motor.motor_peak_torque = $$v
        },
        expression: "motor.motor_peak_torque"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("N.米")])], 2)], 1)], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitAddForm('addDialogData')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.hideAddDialog
    }
  }, [_vm._v("取消")])], 1)], 2)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formSearch
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "车牌号码"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.queryPlate,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formSearch.plate_number),
      callback: function($$v) {
        _vm.formSearch.plate_number = $$v
      },
      expression: "formSearch.plate_number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电池编码"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.queryBattery,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formSearch.battery_code),
      callback: function($$v) {
        _vm.formSearch.battery_code = $$v
      },
      expression: "formSearch.battery_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmitSearch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onResetSearch
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAddCar
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onDownload
    }
  }, [_vm._v("下载模板")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadVisible = true
      }
    }
  }, [_vm._v("批量导入")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "80",
      "prop": "plate_number",
      "label": "车牌号码",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "80",
      "prop": "vehicle_type",
      "label": "车辆型号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "80",
      "prop": "electric_endurance_mileage",
      "label": "纯电续驶里程",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.electric_endurance_mileage + 'km') + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "max_velocity",
      "label": "最高车速",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.max_velocity + 'km/h') + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "battery_data",
      "label": "电池编码",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.battery_data[0].battery_sys_code) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "battery_data",
      "label": "电池类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.battery_data[0].battery_type) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "battery_data",
      "label": "电池总能量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.battery_data[0].battery_energy_total + 'w') + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.onEditCar(scope.row)
            }
          }
        }, [_vm._v("\n              编辑\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.showPagination) ? _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.formSearch.page,
      "page-size": _vm.formSearch.rows,
      "layout": " prev, pager, next, sizes, jumper",
      "total": _vm.dataTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.formSearch.page = $event
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-652a0b19"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info-management/cars-info.vue
// module id = 665
// module chunks = 1